var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconRisksStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1773 1.37666C14.716 0.504656 13.2813 0.504656 12.82 1.37666L0.819976 24.0433C0.711954 24.2465 0.658402 24.4742 0.664536 24.7042C0.670671 24.9342 0.736283 25.1587 0.854981 25.3558C0.973678 25.5529 1.14141 25.7159 1.34184 25.8289C1.54227 25.9419 1.76855 26.0011 1.99864 26.0007H25.9986C26.2286 26.0011 26.4547 25.942 26.655 25.8291C26.8553 25.7161 27.0229 25.5532 27.1415 25.3562C27.26 25.1592 27.3256 24.9348 27.3316 24.705C27.3376 24.4751 27.284 24.2476 27.176 24.0447L15.1773 1.37666ZM15.332 22.0007H12.6653V19.334H15.332V22.0007ZM12.6653 16.6673V10.0007H15.332L15.3333 16.6673H12.6653Z",
    fill: "#E56F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconRisksStatus);
export default __webpack_public_path__ + "static/media/TH-Icon-Risks-Status.32462ead7a3ed653089d063c9f78cec5.svg";
export { ForwardRef as ReactComponent };